'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');

var states = {
    lastId: 0,
    setIds: function () { },
    props: {},
    removeId: function (id) {
        var ids = this.getIds();
        ids.splice(ids.indexOf(id), 1);
        delete this.props[id];
        this.setIds(ids);
    },
    addProps: function (id, prop) {
        states.props[id] = prop;
    },
    getIds: function () {
        return Object.keys(this.props);
    },
    show: function (prop) {
        /* create unique id using incremental number */
        var id = this.lastId + 1;
        states.lastId = id;
        states.setIds(function (prev) {
            var newIds = tslib_es6.__spreadArrays(prev);
            newIds.push(id);
            return newIds;
        });
        this.addProps(id, prop);
    },
};

exports.states = states;
//# sourceMappingURL=modalState.js.map
